import BaseClient from '@/app/model/api/response/baseApiClient'

class RecordEditApi extends BaseClient {
  public doRecordEdit (bodyData: {[key:string]: any}, id: string, date: number) {
    const path:string = '/v1/planting-records/' + id + '/' + date

    /* 共通処理 */
    return super.setBody(JSON.stringify(bodyData)).doFetch(process.env.VUE_APP_API_URL + path, 'PUT')
  }
}

export default new RecordEditApi()
